<div class="body-app mt-3 mb-3">
    <div class="content-app">
        <br />
        <div class="row mb-2">
            <div class="col-xl-6 col-lg-7 col-md-12 col-sm-12 col-12">
                <h5 class="mt-0 mb-2">
                    {{jobOffer().title}}
                </h5>
            </div>

<div class="container" 
     appViewTracker 
     [viewType]="ViewType.JobOffer" 
     [entityId]="jobOfferId() || 0">

</div>
            <div class="col-xl-6 col-lg-5 col-md-12 col-sm-12 col-12">
                <div class="text-end">
                    <button (click)="goBack()" type="button" class="btn btn-secondary me-2">
                        <i class="fa-solid fa-arrow-left"></i>
                        Volver atras
                    </button>
                    <a href="javascript:void(0);" class="d-inline-block text-decoration-none mx-2"
                        data-bs-toggle="modal" data-bs-target="#modalCompartirOfertaPublicIn"
                        (click)="beforeOpenShareModal()">
                        <i class="fa-solid fa-share-from-square"></i>
                        Compartir
                    </a>
                    <a href="javascript:void(0);" class="d-inline-block text-decoration-none mx-2"
                        data-bs-toggle="modal" data-bs-target="#modalReferirCandidato">
                        <i class="fa-solid fa-circle-user"></i>
                        Referir a un amigo
                    </a>
                    @if(canUserApply() && !jobOffer().appliedOffer && jobOffer().id > 0){
                    <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                        data-bs-target="#modalAplicarTrabajo">
                        <i class="fa-regular fa-circle-check"></i>
                        Aplicar al trabajo
                    </button>
                    }
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-12">
                <div class="card mb-2">
                    <div class="card-body">
                        <div class="text-center">
                            @if (jobOffer().logoUrl) {
                                <img [src]="jobOffer().logoUrl" alt="logo" class="img-fluid" 
                                onerror="this.error=null; this.src='assets/Images/no-image.jpg'"
                                 style="max-width: 120px;"/>
                            }@else {
                                <img src="assets/Images/logo-compania.jpg" alt="logo" class="img-fluid"
                                    style="max-width: 120px;" />
                            }
                        </div>
                        <h5 class="mt-4 mb-3 text-center">
                            {{jobOffer().ownerFullName}}
                        </h5>
                        <div class="table-responsive">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Compañia</span></td>
                                        <td class="text-end">{{jobOffer().ownerFullName}}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Ubicación</span></td>
                                        <td class="text-end">
                                            {{ jobOffer().countryName }} / {{ jobOffer().stateName }} / {{
                                            jobOffer().cityName }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Lugar donde se
                                                desempeñara</span></td>
                                        <td class="text-end">{{jobOffer().address}}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Puestos</span></td>
                                        <td class="text-end">{{jobOffer().vacantPositions | number}}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Tipo de contratación</span>
                                        </td>
                                        <td class="text-end">{{jobOffer().contractTypeName}}</td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="text-start"><span class="text-secondary">Tiempo de trabajo</span></td>
                                        <td class="text-end">{{jobOffer().workingTime}}</td>
                                    </tr> -->
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Duración del contrato</span>
                                        </td>
                                        <td class="text-end">{{jobOffer().contractDurationName}}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Fecha de publicación</span>
                                        </td>
                                        <td class="text-end">{{(jobOffer().publicOn || jobOffer().createDate) | date: 'dd/MM/yyyy'}}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Fecha de cierre</span>
                                        </td>
                                        <td class="text-end">{{jobOffer().closeOn | date: 'dd/MM/yyyy'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                @if(canUserApply() && !jobOffer().appliedOffer){
                <div class="card mb-2">
                    <div class="card-body">
                        <div class="text-center">
                            @if(!jobOffer().appliedOffer && jobOffer().id > 0){
                                <button type="button" class="btn btn-primary btn-lg" data-bs-toggle="modal"
                                    data-bs-target="#modalAplicarTrabajo">
                                    <i class="fa-regular fa-circle-check"></i>
                                    Aplicar al trabajo
                                </button>
                            }
                        </div>
                    </div>
                </div>
                }
                @if(!canUserApply() || (isLoggedIn() && !isCandidate())){
                    <div class="card mb-2">
                        <div class="card-body">
                            <div class="text-center">
                                @if(!canUserApply()){
                                    <p class="text-muted">Debe iniciar sesión como candidato para aplicar a este trabajo</p>
                                }
                                @if(isLoggedIn() && !isCandidate()){
                                    <p class="text-muted">Solo los candidatos pueden aplicar a las ofertas laborales</p>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12">
                <div class="card">
                    <div class="card-body">
                        <strong class="text-secondary">
                            Descripción del trabajo
                        </strong>
                        <p class="mt-0 mb-2 text-justify">
                            {{jobOffer().description}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalAplicarTrabajo" tabindex="-1" aria-labelledby="modalAplicarTrabajoLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalAplicarTrabajoLabel">Aplicar al trabajo</h1>
                <button type="button" class="btn-close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <p class="mb-2">
                    Seleccione por favor el curriculum con el que desea aplicar al trabajo:
                </p>
                <ul class="list-group">
                    @for (item of resumes(); track $index) {
                    <li class="list-group-item">
                        <h5 class="mt-0 mb-1">
                            <div class="form-check">
                                <input [(ngModel)]="resumeId" class="form-check-input" type="radio" name="curriculum"
                                    [id]="item.id" [value]="item.id">
                                <label class="form-check-label" for="curriculum1">
                                    {{item.name}}
                                </label>
                            </div>
                        </h5>
                        <p class="ms-4 mb-1">
                            {{item.description}}
                        </p>
                    </li>
                    }
                </ul>
                <hr class="mt-3 mb-3" />
                <div class="mt-2 mb-2 text-end">
                    <button [disabled]="isLoading()" (click)="closeModal()" type="button" class="btn btn-secondary me-2">
                        Cancelar
                    </button>
                    @if(canUserApply() && !jobOffer().appliedOffer){
                    <button [disabled]="!resumeId() || isLoading()" (click)="submit()" type="button" class="btn btn-primary">
                        @if (isLoading()) {
                            <div class="spinner-border spinner-border-sm text-light" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <span> Cargando...</span>
                        }@else {
                             Aplicar al trabajo
                        }
                    </button>
                    }
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalReferirCandidato" tabindex="-1" aria-labelledby="modalReferirCandidatoLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalReferirCandidatoLabel">Referir candidato</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form-group mb-3">
                    <label>Correo electrónico de su candidato para aplicar al trabajo:</label>
                    <div class="input-group">
                        <input type="text" class="form-control" />
                        <button type="button" class="btn btn-primary">
                            <i class="fa-solid fa-magnifying-glass"></i>
                            Buscar
                        </button>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <p class="text-secondary mb-1">Candidato seleccionado:</p>
                        <h5 class="text-primary">
                            Oscar Isac Morales Estrada
                        </h5>
                    </div>
                </div>
                <hr class="mt-3 mb-3" />
                <div class="mt-2 mb-2 text-end">
                    <button type="button" class="btn btn-secondary me-2">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-primary">
                        Referir candidato
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalCompartirOfertaPublicIn" tabindex="-1" aria-labelledby="modalCompartirLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalCompartirLabel">Compartir</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p class="text-left">
                    Seleccione el medio por el cual desea compartir el link:
                </p>
                <div class="row">
                    <div class="col-6 text-center">
                        <a [href]="'mailto:?subject=Revisa esta oferta de trabajo&body=' + selectedJobUrl"
                            target="_blank" class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
                            title="Correo electrónico">
                            <i class="fa-regular fa-envelope fa-3x"></i>
                            Correo electrónico
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a [href]="'https://www.facebook.com/sharer/sharer.php?u=' + selectedJobUrl" target="_blank"
                            class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
                            title="Facebook">
                            <i class="fa-brands fa-facebook fa-3x"></i>
                            Facebook
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a href="javascript:void(0);" (click)="copyToClipboard()"
                            class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
                            title="Instagram">
                            <i class="fa-brands fa-instagram fa-3x"></i>
                            Instagram
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a [href]="'https://twitter.com/intent/tweet?text=Mira esta oferta de trabajo: ' + selectedJobUrl"
                            target="_blank" class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
                            title="X">
                            <i class="fa-brands fa-x-twitter fa-3x"></i>
                            X
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a [href]="'https://wa.me/?text=' + selectedJobUrl" target="_blank"
                            class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
                            title="Whatsapp">
                            <i class="fa-brands fa-whatsapp fa-3x"></i>
                            Whatsapp
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a [href]="'https://t.me/share/url?url=' + selectedJobUrl + '&text=Te comparto esta oferta de empleo'"
                            target="_blank" class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
                            title="Telegram">
                            <i class="fa-brands fa-telegram fa-3x"></i>
                            Telegram
                        </a>
                    </div>
                    <div class="col-12 text-center">
                        <button class="btn btn-outline-dark mt-2" (click)="copyToClipboard()">
                            <i class="fa-regular fa-copy"></i> Copiar enlace
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>